import {
	composeValidators,
	FormHelperText,
	isRequired,
	type SniCode,
	SniInput,
	Stack,
} from "@sveabank/cc-common";
import { useMemo } from "react";
import { Field } from "react-final-form";

type Props = {
	allSniCodes: Array<SniCode>;
	initialValues?: Array<string>;
};

export const SniCodesField = ({ allSniCodes, initialValues }: Props) => {
	const initialFieldValue = useMemo(() => initialValues || [], []);

	return (
		<Field<Array<string>>
			name="sniCodes"
			initialValue={initialFieldValue}
			validate={composeValidators(isRequired)}
		>
			{({ input, meta }) => {
				const onAddClick = (sniCode: string) => {
					input.onChange(
						!input.value.includes(sniCode) ? [...input.value, sniCode] : [...input.value],
					);
				};

				const onDeleteClick = (sniCode: string) => {
					input.onChange(input.value.filter((c) => c !== sniCode));
				};

				return (
					<Stack gap={2}>
						<SniInput
							sniCodes={allSniCodes}
							selectedCodes={input.value}
							onAdd={onAddClick}
							onDelete={onDeleteClick}
						/>
						{!!meta.error && !!meta.submitFailed && (
							<FormHelperText align="right" error>
								{meta.error}
							</FormHelperText>
						)}
					</Stack>
				);
			}}
		</Field>
	);
};
